import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import { calculateOverallTotals } from 'modules/finance/components/Quotes/QuotePhasesTable/_Body/lib/calculations'
import type {
  QuoteItem,
  QuotePhase,
} from 'modules/finance/components/Quotes/QuotePhasesTable/types'

interface TotalRowProps {
  phases: QuotePhase[]
  standaloneItems?: QuoteItem[]
  currency: string
}

const TotalRow = ({ phases, standaloneItems = [], currency }: TotalRowProps) => {
  const {
    access: { locale },
  } = useCurrentSession()
  const { totalCost, totalToBill, totalHours } = calculateOverallTotals(phases, standaloneItems)

  return (
    <Table.Row background="grey200">
      <Table.Cell colSpan={2}>
        <Text size="300" weight="semibold" color="grey1000">
          {i18n.t('common.total')}
        </Text>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Text size="300">{i18n.t('finance.quotes.quote_phases_table.sum')}</Text>{' '}
        <Text size="300" weight="semibold" color="grey1000">
          {i18n.t('common.decimal_to_time.hours.basic.hour_amount', {
            total: totalHours,
          })}
        </Text>
      </Table.Cell>
      <Table.Cell colSpan={2} />
      <Table.Cell colSpan={2} />
      <Table.Cell colSpan={2} />
      <Table.Cell colSpan={2}>
        <Box flexDirection="row" gap="s4" justifyContent="flexEnd">
          <Text size="300">{i18n.t('finance.quotes.quote_phases_table.sum')}</Text>
          <Text size="300" color="grey1000" weight="semibold">
            {MoneyWithCurrency({
              optionalDecimals: true,
              amount: totalCost,
              currency,
              locale,
            })}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box flexDirection="row" gap="s4" justifyContent="flexEnd">
          <Text size="300">{i18n.t('finance.quotes.quote_phases_table.sum')}</Text>
          <Text size="300" color="grey1000" weight="semibold">
            {MoneyWithCurrency({
              optionalDecimals: true,
              amount: totalToBill,
              currency,
              locale,
            })}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell width={80} colSpan={1} />
    </Table.Row>
  )
}

export default TotalRow
